import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=e98ff864&scoped=true"
import script from "./CountryList.vue?vue&type=script&lang=js"
export * from "./CountryList.vue?vue&type=script&lang=js"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=e98ff864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98ff864",
  null
  
)

export default component.exports